// extracted by mini-css-extract-plugin
module.exports = {"deletedItens":"DeleteItens_deletedItens__3XnaE","item":"DeleteItens_item__24GMp"};